/**
 * Shared image display controls for Builder carousel items.
 * Lets editors choose which part of an image stays visible when the
 * container crops it (focal point), and whether the image should fill
 * the container (cover, crops overflow) or fit inside it (contain, shows
 * the whole image).
 */

export const IMAGE_FOCAL_POINT_OPTIONS = [
  "Center",
  "Top",
  "Bottom",
  "Left",
  "Right",
  "Top left",
  "Top right",
  "Bottom left",
  "Bottom right",
] as const;

export type BuilderImageFocalPoint = (typeof IMAGE_FOCAL_POINT_OPTIONS)[number];

export const IMAGE_FIT_OPTIONS = ["Cover", "Contain"] as const;

export type BuilderImageFit = (typeof IMAGE_FIT_OPTIONS)[number];

/** Maps the Builder enum value to a valid CSS position keyword. */
export function toCssImagePosition(position: BuilderImageFocalPoint | undefined): string {
  return (position ?? "Center").toLowerCase();
}
